import { Screen } from "styles/antTheme/Variables";
import useMediaQuery from "usehooks-ts/dist/esm/useMediaQuery/useMediaQuery";

/**
 * Trigger query for switching to card view. Matches the breakpoint Time Clock
 * uses (`max-width: 992px` — anything at or below the desktop breakpoint).
 * Centralized so adjusting the breakpoint is a one-line change everywhere.
 */
export const GRID_CARD_VIEW_MEDIA_QUERY = `(max-width: ${Screen.lg}px)`;

/**
 * Returns true when the grid should render its card-view fallback instead of
 * the Kendo grid. Two conditions must both be met:
 *  - the consumer has opted in via `gridCardView.enabled`
 *  - the viewport is at or below the desktop breakpoint
 *
 * Builder-flag gating (e.g., `mobileWebviewExperience`) lives at the consumer
 * level, not in commonComponents — feature pages decide whether to opt in
 * based on the flags they have access to and pass the resolved boolean into
 * `enabled`. Centralizing the flag check here would force commonComponents to
 * read `BuilderInfoContext`, which is restricted (commonComponents may render
 * outside a builder session).
 */
export const useShouldShowGridCardView = (enabled: boolean | undefined): boolean => {
    const isAtOrBelowDesktop = useMediaQuery(GRID_CARD_VIEW_MEDIA_QUERY);
    if (!enabled) {
        return false;
    }
    return isAtOrBelowDesktop;
};
